module.exports = __webpack_public_path__ + "assets/ic_condition_white_05.c1287d4e.svg";